import { TImage } from "../../../types";
import styles from "./article-header.module.less";

export type TArticleHeaderProps = {
  eyebrow?: string;
  category?: string;
  heading: string;
  imageDesktop?: TImage;
  imageMobile?: TImage;
};

export const ArticleHeader = ({ eyebrow, category, heading, imageDesktop, imageMobile }: TArticleHeaderProps) => {
  return (
    <section className={[styles.wrapper, "max-width padded-sides"].join(" ")}>
      <div className={styles.innerWrapper}>
        <div className={styles.textWrapper}>
          <div className={styles.eyebrowCategoryWrapper}>
            {eyebrow && <p className={`eyebrow`}>{eyebrow}</p>}
            {category && <p className={[styles.category, "eyebrow"].join(" ")}>{category}</p>}
          </div>
          <h1 className={[styles.heading, "h2 heading-max-width"].join(" ")}>{heading}</h1>
        </div>
        {(imageDesktop?.url || imageMobile?.url) && (
          <div className={[styles.imageWrapper, !imageDesktop?.url && styles.noDesktopImage].join(" ")}>
            <picture>
              <source srcSet={imageMobile?.url} media="(max-width: 767px)" />
              <source srcSet={imageDesktop?.url} media="(min-width: 768px)" />
              <img src={imageDesktop?.url} className={styles.image} alt={imageDesktop?.alt || imageMobile?.alt} />
            </picture>
          </div>
        )}
      </div>
    </section>
  );
};

export default ArticleHeader;
